import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { previewModeEnabled } from '../features/system/store/toastSlice.js';

export function PreviewModeBoot() {
  const dispatch = useDispatch();
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('previewMode') === '1') {
      dispatch(previewModeEnabled());
    }
  }, [dispatch]);
  return null;
}
